import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import ActionLogTitle from './ActionLogTitle';
import ActionLogSearchBox from './ActionLogSearchBox';
import ActionLogLists from './ActionLogList';
import ActionLogMediaDialog from './ActionLogMediaDialog';
import { ActionTypes as types } from '../../actions/actionLog';
import Pagination from '../Parts/Pagination';
import {
  MainBlock,
  BodyBlock,
  ListsWrapper,
} from './styles/ActionLogPageStyles';

const ActionLogPage = ({
  dispatch,
  apiToken,
  searchOptions,
  currentPage,
  logs,
  groups,
  operators,
  totalNumber,
  totalPages,
  media,
}) => {
  const [isMediaDialog, setIsMediaDialog] = useState(false);

  return (
    <MainBlock className="actionLogPage">
      <Toaster />
      <BodyBlock>
        <ActionLogTitle />
        <ActionLogSearchBox
          dispatch={dispatch}
          apiToken={apiToken}
          searchOptions={searchOptions}
          page={currentPage}
          groups={groups}
          operators={operators}
        />
        <ListsWrapper>
          <ActionLogLists
            logs={logs}
            groups={groups}
            onUpdateMedia={value => {
              dispatch({ type: types.UPDATE_MEDIA, media: value });
              setIsMediaDialog(true);
            }}
          />
        </ListsWrapper>
        <Pagination
          id="ActionLogPagination"
          totalNumber={totalNumber}
          totalPages={totalPages}
          currentPage={currentPage}
          onSelect={page => dispatch({ type: types.UPDATE_SEARCH_PAGE, page })}
        />
        {isMediaDialog && (
          <ActionLogMediaDialog
            media={media}
            onCloseDialog={() => setIsMediaDialog(false)}
          />
        )}
      </BodyBlock>
    </MainBlock>
  );
};

ActionLogPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  apiToken: PropTypes.string.isRequired,
  searchOptions: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  logs: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  operators: PropTypes.array.isRequired,
  totalNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  media: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  searchOptions: state.actionLog.searchOptions,
  currentPage: state.actionLog.page,
  logs: state.actionLog.logs,
  groups: state.actionLog.groups,
  operators: state.actionLog.operators,
  totalNumber: state.actionLog.totalNumber,
  totalPages: state.actionLog.totalPages,
  media: state.actionLog.media,
});

export default withRouter(connect(mapStateToProps)(ActionLogPage));
